"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonEditorFontSizeOptions = exports.BronsonEditorHistoryOptions = exports.BronsonEditorLinkOptions = exports.BronsonEditorTextAlignOptions = exports.BronsonEditorListOptions = exports.BronsonEditorBlockTypeOptions = exports.BronsonEditorInlineOptions = exports.BronsonEditorOptions = void 0;
var BronsonEditorOptions;
(function (BronsonEditorOptions) {
    BronsonEditorOptions["inline"] = "inline";
    BronsonEditorOptions["blockType"] = "blockType";
    BronsonEditorOptions["fontSize"] = "fontSize";
    BronsonEditorOptions["fontFamily"] = "fontFamily";
    BronsonEditorOptions["list"] = "list";
    BronsonEditorOptions["textAlign"] = "textAlign";
    BronsonEditorOptions["colorPicker"] = "colorPicker";
    BronsonEditorOptions["link"] = "link";
    BronsonEditorOptions["embedded"] = "embedded";
    BronsonEditorOptions["emoji"] = "emoji";
    BronsonEditorOptions["image"] = "image";
    BronsonEditorOptions["remove"] = "remove";
    BronsonEditorOptions["history"] = "history";
})(BronsonEditorOptions = exports.BronsonEditorOptions || (exports.BronsonEditorOptions = {}));
var BronsonEditorInlineOptions;
(function (BronsonEditorInlineOptions) {
    BronsonEditorInlineOptions["bold"] = "bold";
    BronsonEditorInlineOptions["italic"] = "italic";
    BronsonEditorInlineOptions["underline"] = "underline";
    BronsonEditorInlineOptions["strikethrough"] = "strikethrough";
    BronsonEditorInlineOptions["monospace"] = "monospace";
    BronsonEditorInlineOptions["superscript"] = "superscript";
    BronsonEditorInlineOptions["subscript"] = "subscript";
})(BronsonEditorInlineOptions = exports.BronsonEditorInlineOptions || (exports.BronsonEditorInlineOptions = {}));
var BronsonEditorBlockTypeOptions;
(function (BronsonEditorBlockTypeOptions) {
    BronsonEditorBlockTypeOptions["Normal"] = "Normal";
    BronsonEditorBlockTypeOptions["H1"] = "H1";
    BronsonEditorBlockTypeOptions["H2"] = "H2";
    BronsonEditorBlockTypeOptions["H3"] = "H3";
    BronsonEditorBlockTypeOptions["H4"] = "H4";
    BronsonEditorBlockTypeOptions["H5"] = "H5";
    BronsonEditorBlockTypeOptions["H6"] = "H6";
    BronsonEditorBlockTypeOptions["Blockquote"] = "Blockquote";
    BronsonEditorBlockTypeOptions["Code"] = "Code";
})(BronsonEditorBlockTypeOptions = exports.BronsonEditorBlockTypeOptions || (exports.BronsonEditorBlockTypeOptions = {}));
var BronsonEditorListOptions;
(function (BronsonEditorListOptions) {
    BronsonEditorListOptions["unordered"] = "unordered";
    BronsonEditorListOptions["ordered"] = "ordered";
    BronsonEditorListOptions["indent"] = "indent";
    BronsonEditorListOptions["outdent"] = "outdent";
})(BronsonEditorListOptions = exports.BronsonEditorListOptions || (exports.BronsonEditorListOptions = {}));
var BronsonEditorTextAlignOptions;
(function (BronsonEditorTextAlignOptions) {
    BronsonEditorTextAlignOptions["left"] = "left";
    BronsonEditorTextAlignOptions["center"] = "center";
    BronsonEditorTextAlignOptions["right"] = "right";
    BronsonEditorTextAlignOptions["justify"] = "justify";
})(BronsonEditorTextAlignOptions = exports.BronsonEditorTextAlignOptions || (exports.BronsonEditorTextAlignOptions = {}));
var BronsonEditorLinkOptions;
(function (BronsonEditorLinkOptions) {
    BronsonEditorLinkOptions["link"] = "link";
    BronsonEditorLinkOptions["unlink"] = "unlink";
})(BronsonEditorLinkOptions = exports.BronsonEditorLinkOptions || (exports.BronsonEditorLinkOptions = {}));
var BronsonEditorHistoryOptions;
(function (BronsonEditorHistoryOptions) {
    BronsonEditorHistoryOptions["undo"] = "undo";
    BronsonEditorHistoryOptions["redo"] = "redo";
})(BronsonEditorHistoryOptions = exports.BronsonEditorHistoryOptions || (exports.BronsonEditorHistoryOptions = {}));
var BronsonEditorFontSizeOptions;
(function (BronsonEditorFontSizeOptions) {
    BronsonEditorFontSizeOptions["seven"] = "7";
    BronsonEditorFontSizeOptions["sevenPlus"] = "7.5";
    BronsonEditorFontSizeOptions["eight"] = "8";
    BronsonEditorFontSizeOptions["eightPlus"] = "8.5";
    BronsonEditorFontSizeOptions["nine"] = "9";
    BronsonEditorFontSizeOptions["ninePlus"] = "9.5";
    BronsonEditorFontSizeOptions["ten"] = "10";
    BronsonEditorFontSizeOptions["tenPlus"] = "10.5";
    BronsonEditorFontSizeOptions["eleven"] = "11";
    BronsonEditorFontSizeOptions["elevenPlus"] = "11.5";
    BronsonEditorFontSizeOptions["twelve"] = "12";
    BronsonEditorFontSizeOptions["twelvePlus"] = "12.5";
    BronsonEditorFontSizeOptions["fourteen"] = "14";
    BronsonEditorFontSizeOptions["sixteen"] = "16";
    BronsonEditorFontSizeOptions["eighteen"] = "18";
    BronsonEditorFontSizeOptions["twenty"] = "20";
    BronsonEditorFontSizeOptions["twentyFour"] = "24";
    BronsonEditorFontSizeOptions["twentySix"] = "26";
    BronsonEditorFontSizeOptions["thirty"] = "30";
})(BronsonEditorFontSizeOptions = exports.BronsonEditorFontSizeOptions || (exports.BronsonEditorFontSizeOptions = {}));
